// eslint-disable-next-line @typescript-eslint/typedef
export const TargetBufferEvents = {
  targetBufferIncreaseRequested: 'targetBuffer.targetBufferIncreaseRequested',
  targetBufferIncreased: 'targetBuffer.targetBufferIncreased',
  targetBufferDecreaseRequested: 'targetBuffer.targetBufferDecreaseRequested',
  originalTargetBufferDecreaseRequested: 'targetBuffer.originalTargetBufferDecreaseRequested',
  originalTargetBufferDisable: 'targetBuffer.originalTargetBufferDisable',
  targetBufferDecreased: 'targetBuffer.targetBufferDecreased',
};

// eslint-disable-next-line @typescript-eslint/typedef
export const PlaybackSpeedEvents = {
  setPlaybackSpeed: 'playbackSpeed.setPlaybackSpeed',
};
